import React from 'react'

import View from './view.js'
import { useOnChange } from './helpers.js'

export default function Logic(props) {
  let onChange = useOnChange(props)
  return <View {...props} onSelectPayor={onChange} />
}
